export const getReplacePageKey = (replaced_dynamic_pages, page_key) => {
  return replaced_dynamic_pages?.find?.((r_page) => r_page.value === page_key)
    ?.key
    ? replaced_dynamic_pages?.find?.((r_page) => r_page.value == page_key)?.key
    : null;
};
